import * as React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableCaption,
  TableHead,
  TableHeader,
  TableRow,
} from "@src/ui/views/table";
import { Button } from "@src/ui/views/button";
import { useGetAllTimedShuttlesDefinitionsQuery } from "@src/features/timed-shuttles/redux/timed-shuttles-api";
import { type ShuttleDefinition } from "@src/features/shuttles/shuttles-models";

export function TimedShuttleAllDefinitionsScreen() {
  const { spaceId } = useParams<{ spaceId: string }>();
  const navigate = useNavigate();

  const {
    data,
    isLoading,
    isError,
  } = useGetAllTimedShuttlesDefinitionsQuery({ spaceId: spaceId! });

  if (isLoading) {
    return <p>Loading shuttle definitions...</p>;
  }
  if (isError || !data) {
    return <p>Error loading shuttle definitions</p>;
  }

  const definitions: ShuttleDefinition[] = data.shuttleDefinitions;

  return (
    <div className="h-full p-4">
      <Table className="w-full">
        <TableCaption className="pb-2 text-xl font-semibold text-center">
          Shuttle Definitions
        </TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead>Definition Id</TableHead>
            <TableHead>Origin</TableHead>
            <TableHead>Destination</TableHead>
            <TableHead>Type</TableHead>
             <TableHead>Track Id</TableHead>
             <TableHead>Return Definition Id</TableHead>
            <TableHead></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {definitions.map((def) => (
            <TableRow
              key={def.definitionId}
              className="cursor-pointer hover:bg-gray-100"
              
            >
              <TableCell>{def.definitionId}</TableCell>
              <TableCell>{def.originName}</TableCell>
              <TableCell>{def.destName}</TableCell>
              <TableCell>{def.rideType}</TableCell>
              <TableCell>{def.trackId}</TableCell>
              <TableCell>{def.returnDefinitionId}</TableCell>
              <TableCell>
                <Button onClick={() => navigate(`${def.definitionId}`)} variant="link">View Policy</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}